<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="w-75 m-auto">
                            <img class="img-fluid rounded-circle" src="../../../../../../assets/images/warehouse.png">
                        </div>
                    </div>
                    <div class="card-body mt-0 p-t-0 p-b-0">
                        <hr class="m-t-0">
                        <h5 class="mb-0">{{warehouse.name}}</h5>
                        <span class="" v-html="warehouse.description"/>
                        <hr>
                        <address class="mt-2">
                            <strong><i class="fas fa-map-marked-alt"/></strong><br>
                            {{warehouse.address.line1}}<br>
                            <span v-if="warehouse.address.line2">{{warehouse.address.line2}}<br></span>
                            {{warehouse.address.city}}, {{warehouse.address.state}}<br>
                            {{warehouse.address.postal_code}}, {{warehouse.address.country}}<br>
                        </address>
                    </div>
                    <div class="card-footer p-t-0 p-b-0 mb-3">
                        <hr class="m-t-0">
                        <div v-if="currentOrg.role === 'ORG_ADMIN'">
                            <router-link :to="{ name: 'editmarketplacewarehouse', params: {warehouseid: warehouseid}}"
                                         class="btn btn-info ml-auto">Edit
                            </router-link>

                            <button class="btn btn-secondary float-right">Delete</button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-9">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-blue">
                            <div class="card-header">
                                <h4 class="card-title">Transfer stock to Other Warehouse</h4>
                            </div>
                            <form @submit.prevent="handleSubmitTrf">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Warehouse</label>
                                        <div class="col-sm-10">
                                            <multiselect
                                                    :class="{'is-invalid': submitted && errors.has('warehouse')}"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :hide-selected="true"
                                                    :internal-search="false"
                                                    :limit="3"
                                                    :max-height="600"
                                                    :options="warehouses"
                                                    :options-limit="300"
                                                    :searchable="true"
                                                    :show-no-results="false"
                                                    @search-change="searchWareHouses"
                                                    class="form-control multiselect-sm"
                                                    data-vv-as="Warehouse"
                                                    id="Warehouse1"
                                                    label="goodsservice"
                                                    name="warehouse"
                                                    open-direction="bottom"
                                                    placeholder="Search Warehouse"
                                                    selectLabel=""
                                                    track-by="id"
                                                    v-model="trfGood.warehouse"
                                                    v-validate="'required'">
                                                <template slot="singleLabel" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc">
                                                            {{ props.option.name }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc" v-if="props.option">
                                                            <h5>{{ props.option.name }}</h5>
                                                            {{ props.option.description }}
                                                        </div>
                                                        <div class="option__desc" v-else>
                                                            <h5>Add New</h5>
                                                        </div>
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <div class="invalid-feedback"
                                                 v-if="submitted && errors.has('warehouse')">{{
                                                errors.first('warehouse') }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Good</label>
                                        <div class="col-sm-10 mt-2" v-if="!trfGood.good">
                                            <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                               href="javascript:void(0)"><b>Click here to
                                                add commodity</b></a>
                                        </div>
                                        <div class="col-sm-10" v-else>
                                            <p data-target="#searchAndSelectCommodityModal" data-toggle="modal" class="form-control">{{trfGood.good.name}}
                                                <span>({{trfGood.good.code}})</span> -{{trfGood.good.variety}}</p>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Batch</label>
                                        <div class="col-sm-10">
                                            <multiselect :class="{'is-invalid': submitted && errors.has('batch')}"
                                                         :clear-on-select="false"
                                                         :close-on-select="true"
                                                         :hide-selected="false"
                                                         :internal-search="false"
                                                         :limit="3"
                                                         :max-height="600"
                                                         :options="logs_by_good"
                                                         :options-limit="300"
                                                         :searchable="true"
                                                         :show-no-results="false"
                                                         @input="addBatch(selected_batch)"
                                                         @search-change="getLogsByGood"
                                                         class="form-control multiselect-sm "
                                                         data-vv-as="Batch"
                                                         id="batch"
                                                         label="batch"
                                                         name="batch"
                                                         open-direction="bottom"
                                                         placeholder="Search Batch"
                                                         ref="selectedItem"
                                                         selectLabel=""
                                                         track-by="id"
                                                         v-model="selected_batch"
                                                         v-validate="''">
                                                <template slot="singleLabel" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc"
                                                             style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                            {{props.option.number}}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <h5>{{props.option.number}} - {{props.option.quantity | unitFix(2)}}
                                                        {{props.option.unit}}</h5>
                                                    <span>{{props.option.created_at | medium}}</span>
                                                </template>
                                                <span slot="noResult">Oops! No batches found. Consider changing the search query.</span>
                                            </multiselect>
                                        </div>
                                    </div>

                                    <div class="row" v-if="batches.length>0">
                                        <label class="col-sm-2 text-right control-label col-form-label"></label>
                                        <div class="col-sm-10">
                                            <ul class="select2-selection__rendered custom-flex">
                                                <li :id="b" class="selection-choice2" data-select2-id="346" title="blue"
                                                    v-for="(b, index) in batches">
                                                    {{b.number}}<span @click="removeBatch(b)"
                                                                      class="select-remove"> ×</span>
                                                </li>
                                                <li @click="removeAllBatch()" class="remove-all"
                                                    v-if="batches.length>1"><u>Clear
                                                    all</u></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Quantity</label>
                                        <div class="col-sm-10">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                                       class="form-control"
                                                       data-vv-as="Quantity"
                                                       id="quantity1"
                                                       name="quantity"
                                                       placeholder="Quantity"
                                                       step="any"
                                                       type="number"
                                                       v-model="trfGood.quantity"
                                                       v-validate="'required', `between:1,${trfGood.limit}`">
                                                <p :value="trfGood.unit" class="form-control" disabled
                                                   style="max-width: 40px"></p>
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('quantity')">{{
                                                errors.first('quantity')
                                                }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Remarks</label>
                                        <div class="col-sm-10">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('ref')}"
                                                       class="form-control"
                                                       data-vv-as="Remarks"
                                                       id="ref1"
                                                       name="ref"
                                                       placeholder="Remarks"
                                                       type="text"
                                                       v-model="trfGood.ref"
                                                       v-validate="'required'">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('ref')">{{ errors.first('ref') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="form-group m-b-0 text-right">
                                        <div class="button-group">
                                            <button class="btn waves-effect waves-light btn-success" type="submit">
                                                Save
                                            </button>
                                            <button class="btn waves-effect waves-light btn-secondary" type="reset">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds" :pre-commodities="warehouse.inventory"
                                 :single-select="true"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import SearchSelectCommodity from "../../../../common/SearchSelectCommodity";
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Multiselect from "vue-multiselect";

    export default {
        name: "TransferCommodityFromWarehouse",
        components: {SearchSelectCommodity, Multiselect},
        props: ["marketplaceid", "warehouseid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                warehouses: [],
                warehouse: {
                    name: null,
                    description: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null
                    },
                    inventory: [],
                },
                trfGood: {
                    warehouse: null,
                    good: null,
                    quantity: null,
                    unit: null,
                    ref: null,
                    limit: 0
                },
                commodityIds: [],
                logs_by_good: [],
                logs_by_good_bkp: [],
                batches: [],
                selected_batch: null
            }
        },
        mounted() {
            this.getWareHouse();
        },
        methods: {
            async getWareHouse() {
                let reply = await this.$http.get(`/marketplaces/${this.marketplaceid}/warehouses/${this.warehouseid}`);
                this.warehouse = reply.data;
            },
            async searchWareHouses(search) {
                let reply = await this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                        params: {
                            search
                        }
                    });
                this.warehouses = _.filter(reply.data.warehouses, (w) => {
                    return w.id !== Number(this.warehouseid)
                });
            },
            handleSubmitTrf() {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        console.log(valid)
                        if (valid) {
                            this.transferGoodToWarehouse();
                        }
                    });
            },
            async transferGoodToWarehouse() {
                try {
                    let payload = {
                        warehouse_id: this.trfGood.warehouse.id,
                        commodity_id: this.trfGood.good.id,
                        quantity: this.trfGood.quantity,
                        unit_id: this.trfGood.unit.id,
                        ref: this.trfGood.ref,
                        batches: this.batches.map(b => b.number)
                    }
                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/transfer`, payload)
                    this.invGoods = [];
                    await this.$router.push({
                        name: 'viewdeliverynote',
                        params: {deliverynoteid: data.delivery_note_id}
                    });
                    this.$toastr('success', 'Good transferred to warehouse', 'Success');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Could not transfer stock to warehouse', 'Failed');
                }
            },
            setCommodity(e) {
                let commodity = e.length > 0 ? e[0] : null;
                if (commodity) {
                    this.trfGood.unit = commodity.unit;
                    this.trfGood.good = commodity;
                    this.trfGood.limit = this.trfGood.good ? Number(this.trfGood.good.stock) : 0;
                    this.commodityIds = [commodity.id];
                    this.getLogsByGood('');
                }

            },
            async getLogsByGood(searchText) {
                if (this.trfGood.good) {
                    this.trfGood.unit = this.trfGood.good ? this.trfGood.good.unit : null;
                    this.trfGood.limit = this.trfGood.good ? Number(this.trfGood.good.stock) : 0;
                    try {
                        let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/transactions`, {
                            params: {
                                goodid: this.trfGood.good.id,
                                type: 'Add',
                                batch: searchText
                            }
                        });
                        this.logs_by_good_bkp = reply.data.transactions;
                        this.logs_by_good = this.logs_by_good_bkp.filter(log => !this.batches.find(b => b.number === log.number));
                    } catch (e) {

                    }
                }
            },
            addBatch(batch) {
                this.selected_batch = null;
                this.$refs.selectedItem.deactivate();
                this.batches.push(batch);
                this.logs_by_good = this.logs_by_good.filter(log => log.number !== batch.number);
            },
            removeBatch(batch) {
                this.batches = this.batches.filter(b => b.number !== batch.number);
                this.logs_by_good.push(batch);
            },
            removeAllBatch() {
                this.batches = [];
                this.selected_batch = null;
                this.$refs.selectedItem.deactivate();
                this.logs_by_good = this.logs_by_good_bkp;
            }
        }
    }
</script>

<style scoped>
    .selection-choice2 {
        background-color: #e4e4e4;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        color: #3e5569
    }

    .custom-flex {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0
    }

    .remove-all {
        color: #999;
        cursor: pointer;
        display: inline-block;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        font-weight: bold;
    }

    .remove-all:hover {
        color: #333
    }

    .select-remove {
        color: #999;
        cursor: pointer;
        display: inline-block;
        font-weight: bold;
        margin-right: 1px;
        margin-left: 5px;
    }

    .select-remove:hover {
        color: #333
    }

    .highlight {
        color: #fff;
        background-color: #5a6268;
        border-color: #545b62;
    }
</style>
